import { render, staticRenderFns } from "./gSide.vue?vue&type=template&id=215c22cf&scoped=true&"
import script from "./gSide.vue?vue&type=script&lang=js&"
export * from "./gSide.vue?vue&type=script&lang=js&"
import style0 from "./gSide.vue?vue&type=style&index=0&id=215c22cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215c22cf",
  null
  
)

export default component.exports